import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import MultiLanguageInputText from "src/components/Forms/MultiLanguageInputText";
import FormRangeInput from "src/components/Forms/FormRangeInput";

const EditAgeGroupModal = ({
  show,
  toggle,
  ageGroup = {},
  handleSuccess = null,
}) => {
  function validate(values) {
    const errors = {};

    if (!values.name && !values.name_it && !values.name_en) {
      errors.name =
        "Es muss für mindestens eine Sprache ein Name gesetzt sein.";
      errors.name_it =
        "Es muss für mindestens eine Sprache ein Name gesetzt sein.";
      errors.name_en =
        "Es muss für mindestens eine Sprache ein Name gesetzt sein.";
    }

    if (values.from == undefined || values.from == null) {
      errors.from = "Von ist ein Pflichtfeld";
    }

    if (values.to == undefined || values.to == null) {
      errors.to = "Bis ist ein Pflichtfeld";
    }

    return errors;
  }

  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);
    let request;

    if (ageGroup.id) {
      request = axios.put(`/api/v1/age_groups/${ageGroup.id}.json`, {
        age_group: values,
      });
    } else {
      request = axios.post(`/api/v1/age_groups.json`, {
        age_group: values,
      });
    }

    request
      .then(function () {
        toggle();
        handleSuccess();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      });
  }

  const formRef = useRef();

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  return (
    <Modal show={show} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>{!ageGroup.id ? "Erstellen" : "Bearbeiten"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{
            name: ageGroup.name ?? "",
            name_it: ageGroup.name_it ?? "",
            name_en: ageGroup.name_en ?? "",
            from: ageGroup.from ?? 0,
            to: ageGroup.to ?? 120,
          }}
          validate={validate}
          onSubmit={submit}
        >
          {() => (
            <Form autoComplete="false">
              <MultiLanguageInputText
                name="name"
                label="Name"
                languages={["de", "it", "en"]}
                required
              />
              <FormRangeInput
                label="Von"
                name="from"
                min={0}
                max={120}
                required
              />
              <FormRangeInput
                label="Bis"
                name="to"
                min={0}
                max={120}
                required
              />
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAgeGroupModal;
